module.exports = __webpack_public_path__ + "img/社区版.926a8f2b.jpg";